import styled from 'styled-components'

import { Layout, Text } from '@loadsmart/miranda-react'
import { getHexColor } from '@loadsmart/miranda-react/dist/tokens'

import { type Shipper } from 'core/domain/Shipper'

import { sizes } from 'legacy/styles/screen'

import { type Carrier } from '../domain/Carrier'
import { formatWelcomeMessage } from '../presenter/carrierPresenter'
import logoShipperGuide from './assets/logo-shipperguide.svg'

const HeaderWrapper = styled(Layout.Group)`
  background-color: ${getHexColor('color-primary-100')};
  width: 100%;
`

type RateCommandCenterHeaderProps = {
  carrier?: Carrier
  shipper?: Shipper
  showAllInfo?: boolean
}

export default function RateCommandCenterHeader({
  carrier,
  shipper,
  showAllInfo = true,
}: RateCommandCenterHeaderProps) {
  return (
    <HeaderWrapper gap="none" justify="center">
      <Layout.Stack
        padding="spacing-6"
        style={{
          backgroundColor: getHexColor('color-primary-100'),
          width: '100%',
          maxWidth: sizes.xlg,
        }}
        gap="spacing-6"
      >
        <img src={logoShipperGuide} alt="" width={145} />

        {showAllInfo && (
          <>
            <Layout.Stack gap="spacing-4" paddingT="spacing-6">
              <Text variant="heading-md" color="color-text-inverted">
                {formatWelcomeMessage(carrier)}
              </Text>
              {carrier && (
                <Text variant="body-md" color="color-primary-20">
                  MC {carrier.mc} &bull; DOT {carrier.dot} &bull; SCAC {carrier.scac} &bull;{' '}
                  {carrier.email}
                </Text>
              )}
            </Layout.Stack>
            {shipper && (
              <Layout.Box backgroundColor="color-text-inverted" padding="spacing-6">
                <Layout.Group gap="spacing-2" align="center">
                  <img src={shipper.logoUrl} width={56} alt={shipper.companyName} />
                  <Layout.Stack gap="spacing-2">
                    <Text variant="body-sm" color="color-text-tertiary">
                      Shipper
                    </Text>
                    <Text variant="body-md" color="color-text-primary">
                      {shipper.companyName}
                    </Text>
                  </Layout.Stack>
                </Layout.Group>
              </Layout.Box>
            )}
          </>
        )}
      </Layout.Stack>
    </HeaderWrapper>
  )
}
